export default __webpack_public_path__ + "static/HOGAR-4eab858636051e095c4ebdc539eb29a6.jpg";